import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import { StyledOverlay, StyledContent, StyledCloseButton } from './styles'

// isVisible in content to reset inputs on close
const FullPageModal = ({ content = null, isVisible = false, toggle, id, themeInfos }) => {
  const ref = useRef(null)

  useEffect(() => {
    if (isVisible) {
      ref.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [isVisible])

  return (
    <StyledOverlay $isVisible={isVisible} ref={ref}>
      <StyledContent id={id}>
        {toggle && (
          <StyledCloseButton onClick={toggle} $themeCustom={themeInfos}>
            <img src="/static/svg/icon/back.svg" alt="Close window" />
          </StyledCloseButton>
        )}
        {isVisible && content}
      </StyledContent>
    </StyledOverlay>
  )
}

FullPageModal.propTypes = {
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.any]),
  id: PropTypes.string,
  isVisible: PropTypes.bool,
  toggle: PropTypes.func,
  themeInfos: PropTypes.object,
}

export default FullPageModal
